module.exports = __webpack_public_path__ + "img/Earnings-Illustration.225c2a81.png";